import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { BookOpen, LogOut, Menu, X, Coins } from "lucide-react";
import { LowCreditBanner, useCreditBalance } from "./billing/LowCreditBanner";
import { CostPreviewDialog } from "./billing/CostPreview";
import { useAuth } from "../context/AuthContext";
import { Wordmark } from "./Brand";
import { SideNav } from "./SideNav";
import { WelcomeTour } from "./WelcomeTour";
import { QuickSearch } from "./QuickSearch";

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const credits = useCreditBalance();
  const out = async () => { await logout(); navigate("/login"); };
  const Brand = () => (
    <div className="flex items-center gap-3 px-3 mb-6 pb-5 border-b border-amber-500/15" data-testid="sidebar-brand">
      <BookOpen className="text-amber-400 drop-shadow-[0_0_8px_rgba(199,125,255,0.6)]" size={20} />
      <Wordmark size="md" testId="sidebar-wordmark" />
    </div>
  );
  const Profile = () => (
    <div className="border-t border-slate-800 pt-4 mt-4 px-3">
      <p className="text-sm text-slate-200 truncate" data-testid="current-user-email">{user?.email}</p>
      <p className="text-xs font-mono text-amber-400/80 mb-3" data-testid="current-user-plan">{user?.role === "owner" ? "MASTER OWNER · PREMIUM · $0" : user?.role?.toUpperCase()}</p>
      {user?.role !== "owner" && credits && <NavLink to="/app/billing" onClick={() => setOpen(false)} className="flex items-center gap-1.5 text-xs text-amber-200 hover:text-white mb-3" data-testid="sidebar-credits"><Coins size={13} />{Math.max(0, credits.balance).toLocaleString()} credits · Top up</NavLink>}
      <button onClick={out} className="flex items-center gap-2 text-xs text-slate-400 hover:text-rose-300" data-testid="logout-button"><LogOut size={14} />Sign out</button>
    </div>
  );
  return (
    <div className="min-h-screen flex relative z-10">
      <aside className="hidden lg:flex w-64 shrink-0 flex-col border-r border-amber-500/15 bg-[#0b0614] p-4 sticky top-0 h-screen overflow-y-auto scrollbar-thin">
        <Brand /><div className="flex-1"><SideNav /></div><Profile />
      </aside>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden bg-black/60" onClick={() => setOpen(false)}>
          <aside className="w-72 h-full bg-[#0b0614] p-4 overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <button className="mb-4 text-slate-400" onClick={() => setOpen(false)} data-testid="mobile-nav-close"><X /></button>
            <Brand /><SideNav onNavigate={() => setOpen(false)} /><Profile />
          </aside>
        </div>
      )}
      <main className="flex-1 min-w-0 h-screen overflow-auto scrollbar-thin" data-testid="app-main">
        <div className="lg:hidden flex items-center gap-3 p-4 border-b border-slate-800 bg-slate-950/80 backdrop-blur-xl sticky top-0 z-40">
          <button onClick={() => setOpen(true)} data-testid="mobile-nav-open"><Menu /></button>
          <Wordmark size="sm" tagline={false} testId="mobile-wordmark" />
        </div>
        <div className="p-4 sm:p-6 lg:p-10 max-w-[1400px]"><LowCreditBanner /><Outlet /></div>
        <CostPreviewDialog />
        <WelcomeTour />
        <QuickSearch />
      </main>
    </div>
  );
}
